import React from "react";
import Image from 'next/image';

type IconProps = {
    cls?: string;
    style?: React.CSSProperties;
    type?: "SC" | "GC"
}

const iconStyle: React.CSSProperties = {
    // width: '0.6rem',
    // height: '0.6rem',
    position: 'relative',
}

const iconUrl = {
    SC: "/img/ico_sc.png",
    GC: "/img/ico_gc.png",
}

const SCIcon: React.FC<IconProps> = (props) => {
    const {cls, style = {}, type = "SC"} = props;
    const mergeStyle = Object.assign({}, iconStyle, style);
    return (
        <div className={`sc-icon ${cls}`} style={{...mergeStyle}}>
            <Image
                src={iconUrl[type]}
                alt="ico_sc"
                fill // 使用 fill 属性让图片填满容器
                style={{objectFit: 'cover'}}>
            </Image>
        </div>
    )
}

export default SCIcon;
